<template>
    <PublicLandingPage :page="landingPages.delivery" />
</template>

<script setup lang="ts">
import { landingPages } from '~/fixtures';
</script>
